import React from 'react';
import { NavigationDots, SocialMedia } from '../components';

const today = new Date();
const AppWrap = (Component, idName, classNames) => function HOC() {
  return (
    <div id={idName} className={`app__container ${classNames}`}>
      <SocialMedia />
      <div className="app__wrapper app__flex">
        <Component />

        <div className="copyright">
          <p className="p-text">Built with ❤️</p>
          <p className="p-text">by Sohail | {today.getFullYear()}</p>
        </div>
      </div>
      <NavigationDots active={idName} />
    </div>
  );
};

export default AppWrap;
